import { render } from "./InjuryQuarterAlysis.vue?vue&type=template&id=265a86c7&scoped=true"
import script from "./InjuryQuarterAlysis.vue?vue&type=script&lang=js"
export * from "./InjuryQuarterAlysis.vue?vue&type=script&lang=js"

import "./InjuryQuarterAlysis.vue?vue&type=style&index=0&id=265a86c7&lang=scss&scoped=true"
import "./InjuryQuarterAlysis.vue?vue&type=style&index=1&id=265a86c7&lang=scss&scoped=true"
import "./InjuryQuarterAlysis.vue?vue&type=style&index=2&id=265a86c7&scoped=true&lang=css"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-265a86c7"]])

export default __exports__